/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BooleanResponse } from '../models/boolean-response';
import { insertUserToAudience } from '../fn/mail-chimp/insert-user-to-audience';
import { InsertUserToAudience$Params } from '../fn/mail-chimp/insert-user-to-audience';

@Injectable({ providedIn: 'root' })
export class MailChimpService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `insertUserToAudience()` */
  static readonly InsertUserToAudiencePath = '/rest/mailchimp/insert-user-to-audience';

  /**
   * Insert user into MailChimp audience.
   *
   * Proxy for (See MAilchimp documentation https://mailchimp.com/developer/reference/lists/list-members/)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `insertUserToAudience()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  insertUserToAudience$Response(params: InsertUserToAudience$Params, context?: HttpContext): Observable<StrictHttpResponse<BooleanResponse>> {
    return insertUserToAudience(this.http, this.rootUrl, params, context);
  }

  /**
   * Insert user into MailChimp audience.
   *
   * Proxy for (See MAilchimp documentation https://mailchimp.com/developer/reference/lists/list-members/)
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `insertUserToAudience$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  insertUserToAudience(params: InsertUserToAudience$Params, context?: HttpContext): Observable<BooleanResponse> {
    return this.insertUserToAudience$Response(params, context).pipe(
      map((r: StrictHttpResponse<BooleanResponse>): BooleanResponse => r.body)
    );
  }

}
